var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _vm.isLoading
        ? _c("LoadingSpinner", { attrs: { size: "medium", variant: "inline" } })
        : _vm.loadFailed
        ? _c("p", { staticClass: "load-error", attrs: { role: "alert" } }, [
            _vm._v(_vm._s(_vm.$t("eventContest.error.fetchFailed"))),
          ])
        : _vm.contest
        ? _c("div", { staticClass: "contents" }, [
            _c("article", { staticClass: "body" }, [
              _vm.imageUrl
                ? _c("img", {
                    staticClass: "hero",
                    attrs: { src: _vm.imageUrl, alt: _vm.title },
                  })
                : _vm._e(),
              _c("div", { staticClass: "body-text" }, [
                _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
                _vm.contentHtml
                  ? _c("div", {
                      staticClass: "description",
                      domProps: { innerHTML: _vm._s(_vm.contentHtml) },
                    })
                  : _vm._e(),
              ]),
            ]),
            _c("aside", { staticClass: "summary" }, [
              _c("p", { staticClass: "summary-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c("p", { staticClass: "deadline-label" }, [
                _vm._v(_vm._s(_vm.$t("eventContestV2Detail.deadlineLabel"))),
              ]),
              _c("p", { staticClass: "deadline" }, [
                _vm._v(_vm._s(_vm.deadline)),
              ]),
              _c(
                "button",
                {
                  staticClass: "apply-button",
                  attrs: { type: "button", disabled: !_vm.canApply },
                  on: { click: _vm.onClickApply },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("eventContestV2Detail.applyButton")) +
                      " "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }